import { memo, useRef, useState } from 'react';

import { useWebcam } from '@pages/TwinPage/hooks/useWebCam';

const WebCamView: React.FC = memo(() => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [show, setShow] = useState(true);

  const { stopCamera, startCamera } = useWebcam(videoRef);

  const toggleCam = () => {
    setShow((show) => {
      if (show) {
        stopCamera();
      } else {
        startCamera().catch((error) => {
          console.error('Error starting camera:', error);
        });
      }
      return !show;
    });
  };

  return (
    <div className="hidden sm:block absolute right-4 bottom-4 w-40 h-40 rounded-2xl border-4 border-white transition-colors duration-200 overflow-hidden">
      <div className="absolute inset-0 tc-mv-blur" />
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        disablePictureInPicture
        data-testid="avatar-main-video"
        className="w-full peer h-full object-cover -scale-x-100"
      />
      <button
        data-testid="webcam-toggle-btn"
        onClick={toggleCam}
        className="absolute bottom-4 w-10 h-10 left-1/2 transform -translate-x-1/2 text-white peer-hover:opacity-100 hover:opacity-100 opacity-0 transition-all duration-300">
        <i className={`fa-solid ${show ? 'fa-video' : 'fa-video-slash'}`} />
      </button>
    </div>
  );
});

export { WebCamView };
